import { Injectable } from '@angular/core';
import { UserSessionService } from './usersession.service';
import { DataService } from './data.service';
import { UserSession } from '../models/usersession';
import 'rxjs/add/operator/map';
import { Authenticate, AuthenticateResponse, CardStatus, VersionResponse } from '../models/authentication';
import { Response } from "../models/api-response";

declare var require: any;
const timezone = require('src/assets/timezones.json');

@Injectable()
export class AuthenticationService {

  timeZones: any[];
  pageAccess = true;
  sessionData = new UserSession();


  constructor(
    private dataService: DataService,
    private sessionService: UserSessionService,
  ) {
    this.getTimeZones();
  }


  cardStatus(data: CardStatus) {
    return this.dataService.newpost<Response>('/cardstatus', data);
  }

  Authenticate(data: Authenticate) {
    return this.dataService.newpost<AuthenticateResponse>('/authenticate', data)
      .map(user => {
        if (user && user.value.resultString.authToken) {
          this.sessionData.authToken = user.value.resultString.authToken;
          this.sessionData.profileType = user.value.cardholderDetails.profileType
          this.sessionData.cvvNo = user.value.cardholderDetails.cvvNo
          this.sessionData.cardNumber = user.value.cardholderDetails.cardNumber;
          this.sessionData.expiryDate = user.value.cardholderDetails.expiryDate;
          this.sessionData.cardID = user.value.cardholderDetails.cardID;
          this.sessionData.profileType = user.value.cardholderDetails.profileType;
          this.sessionData.profileId = user.value.cardholderDetails.profileId;
          this.sessionData.trackingNo = user.value.cardholderDetails.trackingNo;
          this.sessionData.cardholderName = user.value.cardholderDetails.cardholderName + ' ' + user.value.cardholderDetails.initalsName;
          this.sessionData.clientId = user.value.cardholderDetails.clientId;
          this.sessionData.mobile = user.value.cardholderDetails.mobile;
          this.sessionService.create(this.sessionData);
        }
        return user;
      });
  }

  getNotification() {
    return this.dataService.newgetData<VersionResponse>('/version', true)
  }

  getTimeZones() {
    this.timeZones = timezone.timeZone;
  }

  logOut() {
    this.sessionService.destroy();
  }

}
